export default "__VITE_ASSET__Bg9y4h4o__"